const SearchIdentificacionForm = {
    submit: {
        label: "Buscar"
    },
    sections: [
        {
            "fields": [
                [
                    {
                        "type": "text",
                        "name": "identificacion",
                        // "isHorizontal": true,
                        "label": "Numero de Identificacion",
                        "labelSizing": {
                            "sm": {
                                "size": 2
                            }
                        },
                        "sizing": {
                            "sm": {
                                "size": 6
                            }
                        }
                    },
                ],
            ]
        }
    ],
};


export default SearchIdentificacionForm;